import {Component, OnInit} from '@angular/core';
import { routeAnimation, routePopupAnimation } from "../../../animations";
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-popin-anchor',
  templateUrl: './popin-outlet.component.html',
  animations: [ routePopupAnimation ]
})
export class PopinOutletComponent implements OnInit{

  constructor() { }

  ngOnInit(): void {  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
}
